import { Dialog, DialogContent, DialogActions, DialogTitle, Button, Grid2, IconButton, Typography, Box } from '@mui/material';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import React, { useState, useEffect } from 'react';
import { myApi } from '../../../../config/axiosConfig';
import Swal from 'sweetalert2';
import { Close } from '@mui/icons-material';
import Cookies from 'js-cookie';
import { base_url_clean } from '../../../../config/urls';

// COMPONENTES
import MyTextInput from '../../../../components/inputs/MyTextInput';

const ModalEditarMenu = ({ open, onClose, refresh, data, isEditing }) => {
    const [imagePreview, setImagePreview] = useState('');

    useEffect(() => {
        if (open && data?.image_url) {
            // Asegura que tenga el formato "/imagen.png"
            const url = data.image_url.startsWith('/')
                ? data.image_url
                : `/${data.image_url}`;

            setImagePreview(url);
        }

        if (!open) {
            // Limpiar cuando el modal se cierra
            setImagePreview('');
        }
    }, [open, data]);

    // ===========================================
    // LIMPIAMOS LA URL DE LA IMAGEN
    // ===========================================

    const handleImageChange = (event, setFieldValue) => {
        const file = event.target.files[0];
        if (file) {
            setFieldValue('image', file);

            // Liberar URL previa si era blob
            if (imagePreview.startsWith('blob:')) {
                URL.revokeObjectURL(imagePreview);
            }

            setImagePreview(URL.createObjectURL(file));
        }
    };

    const submitForm = async (values) => {
        console.log(values);
        console.log(isEditing);
        console.log(data);

        try {
            const formData = new FormData();
            formData.append('name', values.name);
            formData.append('menu_url', values.menu_url);
            
            isEditing ? formData.append("updated_by", Cookies.get('ebt_id_user')) : formData.append("created_by", Cookies.get('ebt_id_user'));

            if (values.image) {
                formData.append('image', values.image);
                if (data?.image_url) {
                    formData.append('image_old_path', data.image_url);
                }
            }

            if (isEditing && data?.menu_id) {
                formData.append('menu_id', data.menu_id); // Asegúrate de tener el ID
            }

            const endpoint = isEditing ? 'update' : 'insert';
            const url = `/menuoperadores/${endpoint}`;

            const config = {
                headers: { 'Content-Type': 'multipart/form-data' },
            };

            const response = isEditing
                ? await myApi.put(url, formData, config)
                : await myApi.post(url, formData, config);

            if (response.data.success) {
                onClose();
                Swal.fire({ icon: "success", title: "Datos guardados" });
                refresh();
            }
        } catch (error) {
            console.error('Error al guardar:', error);
            Swal.fire({ icon: "error", title: "Error al guardar" });
        }
    };

    const handleClose = () => {
        onClose();
        if (imagePreview.startsWith('blob:')) {
            URL.revokeObjectURL(imagePreview);
        }
        setImagePreview('');
    };

    const initialValues = {
        name: data?.name || '',
        menu_url: data?.site_url || '',
        image: data?.image_url || null,
        image_old_path: data?.image_old_path || '',
        menu_id: data?.menu_id || "",
    };

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
            <DialogTitle>
                {isEditing ? 'Editar menú' : 'Crear menú'}
                <IconButton aria-label="close" onClick={handleClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
                    <Close />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ padding: 2 }}>
                <Formik
                    initialValues={initialValues}
                    enableReinitialize
                    validationSchema={Yup.object({
                        name: Yup.string().required('El nombre del menú es obligatorio'),
                        menu_url: Yup.string().required('La URL del menú es obligatoria'),
                        image: Yup.mixed().test('fileRequired', 'La imagen es obligatoria', function (value) {
                            if (isEditing) {
                                return !!value || !!data?.image; // permite imagen previa
                            }
                            return !!value;
                        })
                            .test('fileType', 'Solo se permiten imágenes (jpg, png)', (value) => {
                                if (!value) return true; // skip si no hay valor (lo controla el test anterior)
                                return value.type && value.type.startsWith('image/');
                            })
                    })}
                    onSubmit={submitForm}
                >
                    {({ isSubmitting, touched, errors, setFieldValue, values }) => (
                        <Form style={{ width: '100%' }}>
                            <Grid2 container spacing={2} sx={{ marginTop: 2 }}>
                                <Grid2 size={{ xs: 12 }}>
                                    <MyTextInput name="name" label="Nombre del menú" />
                                </Grid2>

                                <Grid2 size={{ xs: 12 }}>
                                    <MyTextInput name="menu_url" label="URL del menú" />
                                </Grid2>

                                <Grid2 container spacing={2} alignItems="center">
                                    <Grid2 size={{ xs: 12, sm: 6 }} alignItems="center">
                                        <Button variant="outlined" component="label" fullWidth sx={{ height: 50 }}>
                                            Subir Imagen
                                            <input
                                                type="file"
                                                name="image"
                                                accept="image/*"
                                                hidden
                                                onChange={(e) => handleImageChange(e, setFieldValue)}
                                            />
                                        </Button>
                                        {touched.image && errors.image && (
                                            <Typography color="error" variant="caption">
                                                {errors.image}
                                            </Typography>
                                        )}
                                        {values.image && (
                                            <Typography variant="body2" mt={1}>
                                                {values.image.name}
                                            </Typography>
                                        )}
                                    </Grid2>

                                    <Grid2 size={{ xs: 12, sm: 6 }}>
                                        <Box
                                            sx={{
                                                border: '1px solid #ccc',
                                                borderRadius: 2,
                                                overflow: 'hidden',
                                                width: '100%',
                                                aspectRatio: '1 / 1',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                boxShadow: 1,
                                                backgroundColor: '#f9f9f9',
                                            }}
                                        >
                                            {imagePreview ? (
                                                <img
                                                    src={
                                                        imagePreview.startsWith('blob:')
                                                            ? imagePreview // Imagen local
                                                            : `${base_url_clean}img/menuOperadores${imagePreview}` // Imagen guardada
                                                    }
                                                    alt="Preview"
                                                    style={{ width: '100%', height: '100%', objectFit: 'fill' }}
                                                />
                                            ) : (
                                                <Typography variant="caption" color="text.secondary" align="center">
                                                    Vista previa no disponible
                                                </Typography>
                                            )}
                                        </Box>
                                    </Grid2>
                                </Grid2>

                                <DialogActions sx={{ justifyContent: 'flex-end', width: '100%' }}>
                                    <Button type="submit" variant="contained" color="primary" disabled={isSubmitting}>
                                        {isEditing ? 'Guardar' : 'Crear'}
                                    </Button>
                                    <Button onClick={handleClose}>Cancelar</Button>
                                </DialogActions>
                            </Grid2>
                        </Form>
                    )}
                </Formik>
            </DialogContent>
        </Dialog>
    );
};

export default ModalEditarMenu;
